import { DataSource, Label, Layout } from "@mcleod/components";
import { TableCustomerOrders } from "../TableCustomerOrders";

export abstract class AutogenLayoutPopupTableCustomerOrders extends Layout {
    labelDetailForOrder: Label;
    layoutTableCustomerOrder: TableCustomerOrders;
    sourceOrders: DataSource;
}
